import { useQuery } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

import { fetchLayoutType } from '../layoutTypes';
import { mapViewChannels, sortResponse } from './helpers';

export const useViewChannels = () =>
  useQuery({
    queryKey: queryKeys.viewChannels.all(),
    queryFn: fetchViewChannels,
  });

export const fetchViewChannels = async () => {
  const [response, layoutTypes] = await Promise.all([
    requestCCApi({ url: '/viewChannels' }),
    queryClient.fetchQuery({
      queryKey: queryKeys.layoutTypes.all(),
      queryFn: fetchLayoutType,
    }),
  ]);
  const sortedResponse = sortResponse(response);

  return mapViewChannels(sortedResponse, layoutTypes);
};
